export default "__VITE_ASSET__CQeZ6Akc__";